<!--
 * @Author: your name
 * @Date: 2021-01-06 17:09:41
 * @LastEditTime: 2021-01-07 22:05:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sunshineServiceHall\src\components\problem\list.vue
-->
<template>
  <div style="width: 1200px">
    <div class="tablez_bg">
      <div class="title">
        您当前的位置：
        <router-link to="/home">阳光校务服务大厅</router-link>
        &gt; 常见问题
      </div>
    </div>
    <div class="z_title1" style="margin-top: 10px">常见问题</div>
    <div v-for="(item, index) in list" :key="index" class="itemsList">
      <div style="display: flex; align-items: center">
        <img
          style="margin-right: 5px"
          src="@/assets/point.jpg"
          width="4"
          height="4"
        />
        <router-link
          target="_blank"
          class="STYLE1"
          :to="{
            path: '/work/downListInfo',
            query: { record: encodeURIComponent(JSON.stringify(item)) },
          }"
          >{{ item.name }}</router-link
        >
      </div>
      <div align="left" class="STYLE1">{{ item.gmtCreate }}</div>
    </div>
    <a-pagination style="margin-top: 10px" size="small" :total="1" />
  </div>
</template>

<script>
import { getAction, postAction } from "@/api/manage";
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      postAction("/user/appeal/appeal/problem", {
        pageNum: 1,
        pageSize: 10,
      }).then((data) => {
        if (this.$route.query.type === "student") this.list = data.data.student;
        if (this.$route.query.type === "educational")
          this.list = data.data.educational;
        if (this.$route.query.type === "common") this.list = data.data.common;
        if (this.$route.query.type === "teacher") this.list = data.data.teacher;
      });
    },
  },
};
</script>

<style scoped>
.itemsList {
  margin-top: 20px;
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
